import React from "react";

function TypeNoteChip(props) {
  const noteTypeColors = {
    aftercareNote: "#1abc9c", // Dark Turquoise
    medicalNote: "#8e44ad", // Dark Purple
    quickNote: "#27ae60", // Dark Green
    familyNote: "#c0392b", // Dark Red
    supportStaffNote: "#d35400", // Dark Orange
    therapyNote: "#2980b9", // Dark Blue
    handoverNote: "#2c3e50", // Dark Blue-Gray (Previously endOfShift's color)
    groupNote: "#7f8c8d", // Dark Slate Grey
    endOfShift: "#2e4053", // Darker Navy Blue to differentiate from handoverNote
  };

  const backgroundColor = noteTypeColors[props.noteType] || "#333"; // Default color if noteType is not recognized

  return (
    <div
      className="note-type-chip"
      style={{
        backgroundColor: backgroundColor,
        color: "#ffffff", // White text
        padding: "5px 10px",
        borderRadius: "5px",
        display: "inline-block",
      }}
    >
      {props.noteType}
    </div>
  );
}

export default TypeNoteChip;
